// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"vx_a bhp_b"};